// 门店菜单接口
import axios from 'axios'

// 订单列表(分页)
export function getOrderOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/listPage`,
    method: 'get',
    params: data
  })
}
// 订单列表查询(不分页)
export function getOrderAllOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/list`,
    method: 'get',
    params: data
  })
}
// 通过订单号查询门店订单
export function getOrderSnOffline(orderSn) {
  return axios({
    url: `/api/oms/orderOffline/orderByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 通过水洗码/订单编号查询门店订单
export function getOrderByWashOffline(washingCode) {
  return axios({
    url: `/api/oms/orderOffline/orderByWashingCode?washingCode=${washingCode}`,
    method: 'get'
  })
}
// 查询所有门店未完成套餐
export function getListProduct(data) {
  return axios({
    url: `/api/oms/orderOffline/listByAdmin`,
    method: 'get',
    params: data
  })
}

// 门店端-获取商品套餐
export function orderStageAll(data) {
  return axios({
    url: `/api/oms/orderOffline/listByMD`,
    method: 'get',
    params: data
  })
}

// 订单退款(套餐未完成全单退款)
export function storeOrderRefund(paySn) {
  return axios({
    url: `/api/oms/orderOffline/orderRefund?paySn=${paySn}`,
    method: 'get'
  })
}
// 订单转单(未收衣时转单)paySn、stageId、stageName
export function orderTransfer(data) {
  return axios({
    url: `/api/oms/orderOffline/orderTransfer`,
    method: 'get',
    params: data
  })
}

// 订单提前完成paySn
export function cashOutOrder(paySn) {
  return axios({
    url: `/api/oms/orderOffline/cashOutOrder?paySn=${paySn}`,
    method: 'get'
  })
}

// 门店订单取消总检
export function cancelGiById(id) {
  return axios({
    url: `/api/oms/orderOffline/cancelGiById?id=${id}`,
    method: 'get'
  })
}

// 门店订单修改接口(不做任何其他操作，只修改状态)
export function updateOrderOfflineStatus(data){
  return axios({
    url: `/api/oms/orderOffline/updateWashingCode`,
    method: 'post',
    data
  })
}

// 通过水洗码/附件水洗码获取订单衣物washingCode(总检改状态版)
export function orderUpdateOffline(washingCode) {
  return axios({
    url: `/api/oms/orderOffline/totalSelectionByWashingCode?washingCode=${washingCode}`,
    method: 'get'
  })
}
// 订单新增
export function addOrderOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/insert`,
    method: 'post',
    data
  })
}
// 订单返洗接口
export function insertBackOrderOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/insertBack`,
    method: 'post',
    data
  })
}
// 订单删除
export function deleteOrderOffline(id) {
  return axios({
    url: `/api/oms/orderOffline/delete?id=${id}`,
    method: 'get'
  })
}
// 订单修改
export function updateOrderOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/update`,
    method: 'post',
    data
  })
}
// 订单出厂
export function orderExFactoryOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/orderExFactory`,
    method: 'post',
    data
  })
}
// 通过司机ID查询出厂订单
export function listDriverOrder(data) {
  return axios({
    url: `/api/oms/orderOffline/listPageByDriver`,
    method: 'get',
    params: data
  })
}
// 通过订单号获取订单子项
export function orderItemOffline(orderSn) {
  return axios({
    url: `/api/oms/orderOffline/orderItem?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 通过支付订单号获取商品信息
export function orderProductOffline(paySn) {
  return axios({
    url: `/api/oms/orderOffline/orderProduct?paySn=${paySn}`,
    method: 'get'
  })
}

// 通过订单号获取工单
export function orderWorkByOffline(orderSn) {
  return axios({
    url: `/api/oms/orderOffline/workByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}

// 订单附件删除
export function annexDeleteOffline(id) {
  return axios({
    url: `/api/oms/orderItemDetailOffline/delete?id=${id}`,
    method: 'get'
  })
}
// 订单附件新增
export function annexInsertOffline(data) {
  return axios({
    url: `/api/oms/orderItemDetailOffline/insert`,
    method: 'post',
    data
  })
}
// 通过订单编号查询订单附件
export function annexOrderSnOffline(orderSn) {
  return axios({
    url: `/api/oms/orderItemDetailOffline/listByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 订单附件未总检接口返回的是数量
export function listCountOffline(orderSn) {
  return axios({
    url: `/api/oms/orderItemDetailOffline/listByCount?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 订单附件修改
export function annexUpdateOffline(data) {
  return axios({
    url: `/api/oms/orderItemDetailOffline/update`,
    method: 'post',
    data
  })
}
// 通过支付订单号查询订单衣物列表
export function offlinePaySn(data) {
  return axios({
    url: `/api/oms/orderOffline/listMDByPaySn`,
    method: 'get',
    params: data
  })
}

// 衣物列举图片
// ossFolderName
export function listFileOffline(ossFolderName) {
  return axios({
    url: `/api/oms/orderOffline/listFile?ossFolderName=${ossFolderName}`,
    method: 'get'
  })
}
// get衣物上传图片
// file,ossFolderName
export function uploadFileOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/uploadFile`,
    method: 'get',
    params: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post衣物上传图片
export function uploadFilesOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/uploadFile`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post衣物图片删除 filePath,ossFolderName
export function deleteFilesOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/deleteFile`,
    method: 'post',
    params: data
  })
}
// get衣物图片删除filePath,ossFolderName
export function deleteFileOffline(data) {
  return axios({
    url: `/api/oms/orderOffline/deleteFile`,
    method: 'get',
    params: data
  })
}

// 通过订单衣物id查询订单衣物
export function storeSelectById(id) {
  return axios({
    url: `/api/oms/orderOffline/selectById?id=${id}`,
    method: 'get'
  })
}

// 订单分页列表(大订单)
export function orderOfflineParentAll(data){
  return axios({
    url:`/api/oms/orderOfflineParent/listPage`,
    method:'get',
    params:data
  })
}

// 订单不分页列表(大订单)
export function orderOfflineParent(data){
  return axios({
    url:`/api/oms/orderOfflineParent/list`,
    method:'get',
    params:data
  })
}

// 通过订单编号查询父订单
export function orderSnOfflineParent(orderSn){
  return axios({
    url:`/api/oms/orderOfflineParent/orderByOrderSn?orderSn=${orderSn}`,
    method:'get',
  })
}

// 通过支付单号查询大订单
export function orderSnPaySnParent(paySn){
  return axios({
    url:`/api/oms/orderOfflineParent/orderByPaySn?paySn=${paySn}`,
    method:'get',
  })
}

// 修改大订单接口
export function updateOrderParent(data){
  return axios({
    url:`/api/oms/orderOfflineParent/update`,
    method:'post',
    data
  })
}

// 通过工厂id获取线下水洗码
export function selectWashingCodeOffline(id){
  return axios({
    url:`/api/oms/orderOffline/selectWashingCode?factoryId=${id}`,
    method:'get'
  })
}

// 通过支付单号修改衣物订单信息为已收衣
export function updateOrderByPaySn(paySn){
  return axios({
    url:`/api/oms/orderOffline/updateOrderByPaySn?paySn=${paySn}`,
    method:'get'
  })
}

// 通过支付单号修改商品信息为已完成
export function updateProductByPaySn(paySn){
  return axios({
    url:`/api/oms/orderOffline/updateOProductByPaySn?paySn=${paySn}`,
    method:'get'
  })
}

